import { useMutation, useQueryClient } from '@tanstack/react-query';

import { createAdminConversationCategory } from '@features/AdminConversationCreateCategory/api/handlers';

export function useCreateAdminConversationCategoryQuery() {
    const qc = useQueryClient();

    return useMutation({
        mutationFn: createAdminConversationCategory,
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: ['adminConversationCategories'] });
        },
    });
}
